import Conviva from '@convivainc/conviva-js-coresdk';
import { ClientType } from '@mlbtv-clients/services';
import { DeviceTypes } from './types';

const {
  Constants: { DeviceCategory, DeviceType },
} = Conviva;

export enum Distributor {
  comcast = 'comcast',
  web = 'web',
  wwx1 = 'wwx1',
  xglobal = 'xglobal',
}

//these maps are used to translate values for our comcast device types
export const ClientTypeMap: Record<Distributor, ClientType> = {
  [Distributor.comcast]: ClientType.COMCAST_FLEX,
  [Distributor.web]: ClientType.WEB,
  [Distributor.wwx1]: ClientType.COMCAST_FLEX,
  [Distributor.xglobal]: ClientType.COMCAST_XUMO,
};

export const DeviceCategoryMap: Record<DeviceTypes, string> = {
  [DeviceTypes.SMARTTV]: DeviceCategory.SMART_TV,
  [DeviceTypes.STB]: DeviceCategory.SET_TOP_BOX,
  [DeviceTypes.WEB]: DeviceCategory.WEB,
};

export const MetaDataTypeMap: Record<DeviceTypes, string> = {
  [DeviceTypes.SMARTTV]: DeviceType.SMARTTV,
  [DeviceTypes.STB]: DeviceType.SETTOP,
  [DeviceTypes.WEB]: DeviceType.DESKTOP,
};
